import { render, staticRenderFns } from "./ModeloDocumentoRevisaoBotoesAcoes.vue?vue&type=template&id=356e6393"
import script from "./ModeloDocumentoRevisaoBotoesAcoes.vue?vue&type=script&lang=js"
export * from "./ModeloDocumentoRevisaoBotoesAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports